module.exports = __webpack_public_path__ + "static/00054.b4d55188.jpg";